module.exports = __webpack_public_path__ + "static/img/index-v3-tab.22f88e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index-v3-tab.png
// module id = /HVh
// module chunks = 68